import axios from 'axios';

export const getAllCities = () => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getAllCities`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};

export const getJobs = (cityName, clientName = '', userId = null) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getJobs?minSalary=DEFAULT&maxSalary=DEFAULT&client=[${clientName}]&city=[${cityName}]&category=[]&userId=${userId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  config.headers["Accept-Language"] = localStorage.getItem('preferredLanguage');
  
  return axios(config);
};

export const createApplication = data => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/application/create`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data,
  };
  return axios(config);
};

export const getJobApplicationStatusByApplicationId = applicationId => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/application/status/${applicationId}`,
    // url: `https://5fb1-103-40-197-168.in.ngrok.io/jobseeker/application/status/${applicationId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (localStorage.getItem("appVersion")) {
    config.headers['app-vc'] = localStorage.getItem("appVersion");
  };

  config.headers["Accept-Language"] = localStorage.getItem('preferredLanguage');

  return axios(config);
};

export const getUserDetailsById = userId => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/user/getUserDetailsById?userId=${userId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};

export const updateMarketplaceUserDetails = data => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/user/updateUserDetails`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data,
  };
  return axios(config);
};

export const generateJobseekerOtp = siId => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/sendClientOtp`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: {
      scheduledInterviewId: siId,
    },
  };
  return axios(config);
};

export const verifyJobseekerOtp = (siId, otp) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/verifyClientOtp`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: {
      scheduledInterviewId: siId,
      otp,
    },
  };
  return axios(config);
};

export const additionalFormSchema = siId => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/application/personal-info/${siId}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const fetchLocalities = ({ city, client }) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getJobLocations?city=${city}&companyName=${client}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const fetchLocalitiesBySiId = ({ siId }) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getJobLocationsBySiId?siId=${siId}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const getJobComments = companyName => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/get-job-comments/${companyName}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const addJobComment = ({ userId, companyName, cityName, comment }) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/add-job-comment`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: {
      userId,
      companyName,
      cityName,
      comment,
    },
  };
  return axios(config);
};

export const getJobLikesByClient = companyName => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/get-job-likes/${companyName}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const addJobLikeByClient = ({ userId, companyName, cityName }) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/add-job-like`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: {
      userId,
      companyName,
      cityName,
    },
  };
  return axios(config);
};

export const removeJobLikeByClient = ({ userId, companyName, cityName }) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/remove-job-like`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: {
      userId,
      companyName,
      cityName,
    },
  };
  return axios(config);
};

export const checkJobLikedByJobseeker = ({ userId, companyName }) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/is-job-liked-by-jobseeker?userId=${userId}&companyName=${companyName}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
};

export const getZomatoTshirtSize = (phoneNumber) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/zomato/tShirtSizes?phoneNumber=${phoneNumber}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  return axios(config);
}
